"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default=init;// MX-210: no-op due to issue cased by firebase dependencies; we don't currently use firebase
function init(){}